import { VodType, ShowTypes, OnDemandData, ItemPaging, VodContentType, isVMedia, GuideConstants, HomeContentType, ProgramGuide, PlayItem, ContentType, ContentItemProps, ChannelsData } from '@ca.vmedia.tv/domains';

class VodService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    async searchMovies(searchText, pageNumber, itemsOnPage) {
        const response = await this.domains.vodRepository.searchByAll(searchText, itemsOnPage, pageNumber, VodType.All, ShowTypes.Movie);
        const items = response.items ?? [];
        for (let item of items) {
            if (item.images !== null) {
                item.image = await this.domains.imagesRepository.getOnDemandImage(Array.from(item.images));
            }
        }
        response.items = items;
        return response;
    }
    async searchShows(searchText, pageNumber, itemsOnPage) {
        const response = await this.domains.vodRepository.searchByAll(searchText, itemsOnPage, pageNumber, VodType.All, ShowTypes.Series);
        const items = response.items ?? [];
        for (let item of items) {
            if (item.images !== null) {
                item.image = await this.domains.imagesRepository.getOnDemandImage(Array.from(item.images));
            }
        }
        response.items = items;
        return response;
    }
    ;
    /**
     * Load VOD Internal genres without the images
     * @returns the genres map
     */
    async getGenresInternal() {
        const genres = await this.domains.genresRepository.getGenresInternal();
        return genres;
    }
    /**
     * Load genres with the images
     * @returns the genres map
     */
    async getSVODGenres(hasCrave) {
        const genres = await this.domains.genresRepository.getSVODGenres(hasCrave);
        for (let genre of Array.from(genres.keys())) {
            if (genre.id !== null) {
                if (genre.id === 514) {
                    genre.image = await this.domains.imagesRepository.getWhiteCraveImage(genre.id);
                }
                else {
                    genre.image = await this.domains.imagesRepository.getWhiteVodGenreImage(genre.images);
                }
            }
        }
        return genres;
    }
    /**
     * Load Vod internal genres content with the images
     * @returns the Vod content data
     */
    async getVodInternalContent(contentType, itemsCount, pageNumber, genre, requestType, isAvailableOnly, showType, orderBy, cashDisabled) {
        let items = null;
        let totalItems = 0;
        const content = await this.domains.vodRepository.getSVODInternalItems(genre, itemsCount, pageNumber, VodType.SVOD, requestType, isAvailableOnly, showType, orderBy, cashDisabled);
        items = content.items;
        totalItems = content.paging?.totalItems ?? 0;
        if (items === null) {
            return new OnDemandData(null, contentType, new ItemPaging(itemsCount, pageNumber, 0, 0));
        }
        for (let onDemandItem of items) {
            if (onDemandItem.images !== null) {
                onDemandItem.image =
                    await this.domains.imagesRepository.getOnDemandImage(Array.from(onDemandItem.images));
            }
        }
        return new OnDemandData(items, contentType, new ItemPaging(itemsCount, pageNumber, totalItems, totalItems / itemsCount + (totalItems % itemsCount) > 0 ? 1 : 0));
    }
    /**
     * Load Vod content with the images
     * @returns the Vod content data
     */
    async getPopularContent(type, itemsCount, pageNumber, vodType, contentType, genre, showType) {
        let items = null;
        let totalItems = 0;
        const content = await this.domains.vodRepository.getMostPopularVod(type, itemsCount, pageNumber, vodType, genre, showType);
        items = content.items;
        totalItems = content.paging?.totalItems ?? 0;
        if (items === null) {
            return new OnDemandData(null, contentType, new ItemPaging(itemsCount, pageNumber, 0, 0));
        }
        for (let onDemandItem of items) {
            if (onDemandItem.images !== null) {
                onDemandItem.image =
                    await this.domains.imagesRepository.getOnDemandImage(Array.from(onDemandItem.images));
            }
        }
        return new OnDemandData(items, contentType, new ItemPaging(itemsCount, pageNumber, totalItems, totalItems / itemsCount + (totalItems % itemsCount) > 0 ? 1 : 0));
    }
    /**
     * Load Vod content with the images
     * @returns the Vod content data
     */
    async getVodContent(contentType, itemsCount, pageNumber, genre, showType, cashDisabled) {
        let items = null;
        let totalItems = 0;
        switch (contentType) {
            case VodContentType.NewSeries: {
                const content = await this.domains.vodRepository.getNewReleasedShows(itemsCount, pageNumber, genre);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.NewMovies: {
                const content = await this.domains.vodRepository.getNewReleasedMovies(itemsCount, pageNumber, genre);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.RecommendedSeries: {
                items =
                    await this.domains.recommendationsRepository.getSeriesRecommendations(itemsCount);
                totalItems = items.length;
                break;
            }
            case VodContentType.RecommendedMovies: {
                items =
                    await this.domains.recommendationsRepository.getMoviesRecommendations(itemsCount);
                totalItems = items.length;
                break;
            }
            case VodContentType.GenreSubitems: {
                if (genre) {
                    const vodType = (isVMedia && genre.parentId == 514) ? VodType.CraveTV : VodType.All;
                    const content = await this.domains.vodRepository.getSVODItems(genre, itemsCount, pageNumber, vodType, showType, cashDisabled);
                    items = content.items;
                    totalItems = content.paging?.totalItems ?? 0;
                }
                break;
            }
            case VodContentType.ContinueWatching: {
                const content = await this.domains.vodRepository.getContinueWatching(itemsCount, pageNumber, showType);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.RecentlyOnDemand: {
                const content = await this.domains.vodRepository.getRecentlyOnDemand(itemsCount, pageNumber, showType);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.WatchAgain: {
                const content = await this.domains.vodRepository.getWatchAgain(itemsCount, pageNumber, showType);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.MostPopularVod: {
                const content = await this.domains.vodRepository.getMostPopular(itemsCount, pageNumber, showType);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.AllMovies: {
                const content = await this.domains.vodRepository.getAllMovies(itemsCount, pageNumber, genre);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
            case VodContentType.AllShows: {
                const content = await this.domains.vodRepository.getAllShows(itemsCount, pageNumber, genre);
                items = content.items;
                totalItems = content.paging?.totalItems ?? 0;
                break;
            }
        }
        if (items === null) {
            return new OnDemandData([], contentType, new ItemPaging(itemsCount, pageNumber, 0, 0));
        }
        for (let onDemandItem of items) {
            if (onDemandItem.images !== null) {
                onDemandItem.image =
                    await this.domains.imagesRepository.getOnDemandImage(Array.from(onDemandItem.images));
            }
        }
        return new OnDemandData(items, contentType, new ItemPaging(itemsCount, pageNumber, totalItems, Math.ceil(totalItems / itemsCount)));
    }
    async getRelatedSVOD(id, itemsCount, pageNumber) {
        const content = await this.domains.vodRepository.getRelatedSVOD(id, itemsCount, pageNumber);
        if (content.items) {
            for (let onDemandItem of content.items) {
                if (onDemandItem.images !== null) {
                    onDemandItem.image =
                        await this.domains.imagesRepository.getOnDemandImage(Array.from(onDemandItem.images));
                }
            }
        }
        return content;
    }
    async getRelatedCraveTV(id, itemsCount, pageNumber) {
        const content = await this.domains.vodRepository.getRelatedCraveTV(id, itemsCount, pageNumber);
        if (content.items) {
            for (let onDemandItem of content.items) {
                if (onDemandItem.images !== null) {
                    onDemandItem.image =
                        await this.domains.imagesRepository.getOnDemandImage(Array.from(onDemandItem.images));
                }
            }
        }
        return content;
    }
    async getSVODSeasons(id, itemsCount, pageNumber) {
        return await this.domains.vodRepository.getSVODSeasons(id, itemsCount, pageNumber);
    }
    async getCraveTVSeasons(id, itemsCount, pageNumber) {
        return await this.domains.vodRepository.getCraveTVSeasons(id, itemsCount, pageNumber);
    }
    async getSVODSeasonEpisodes(id, itemsCount, pageNumber) {
        const content = await this.domains.vodRepository.getSVODSeasonEpisodes(id, itemsCount, pageNumber);
        if (content.items) {
            for (let onDemandItem of content.items) {
                if (onDemandItem.images !== null) {
                    onDemandItem.image =
                        await this.domains.imagesRepository.getOnDemandEpisodeImage(Array.from(onDemandItem.images));
                }
            }
        }
        return content;
    }
    async getCraveTVSeasonEpisodes(id, itemsCount, pageNumber) {
        const content = await this.domains.vodRepository.getCraveTVSeasonEpisodes(id, itemsCount, pageNumber);
        if (content.items) {
            for (let onDemandItem of content.items) {
                if (onDemandItem.images !== null) {
                    onDemandItem.image =
                        await this.domains.imagesRepository.getOnDemandEpisodeImage(Array.from(onDemandItem.images));
                }
            }
        }
        return content;
    }
}

class SearchService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    /**
     * Get popular search words.
     *
     * @param {string | null} keyword
     * @param {number} take
     * @param {Language} language
     * @return {Promise<StringListSimpleResponse>}
     */
    async getPopularSearchWords(keyword, take, language) {
        return this.domains.searchRepository.getSearchPopularWords(keyword, take, language);
    }
}

class GuideService {
    domains;
    cacheTtl = GuideConstants.CACHE_TTL;
    constructor(domains) {
        this.domains = domains;
    }
    /**
     * Get programs segment for the channel
     *
     * @param {number} channelId - The channel ID
     * @param {Date} segmentDateTime - The date of the segment
     * @return {Promise<ProgramsSegmentModel>}
     */
    // TODO: deprecate, do not use
    async getPrograms(channelIds, segmentDateTime) {
        const result = await this.domains
            .guidesRepository
            .getPrograms(channelIds, segmentDateTime.getTime());
        if (!result) {
            return result;
        }
        for (let model of result) {
            for (let item of model.programs) {
                if (item.images !== null) {
                    item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
                }
                const channelId = item.recentAirTime?.channelId;
                if (!channelId) {
                    continue;
                }
                item.subImage = await this.domains
                    .imagesRepository
                    .getWhiteChannelImage(item.recentAirTime?.imagesChannel);
            }
        }
        return result;
    }
    async loadShowtimes(programId, channelId, pageNumber, itemsOnPage) {
        const guide = await this.domains.guidesRepository.getShowTimes(itemsOnPage, pageNumber, programId, channelId);
        if (guide.items) {
            for (let item of guide.items) {
                if (item.images !== null) {
                    item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
                    const channelId = item.recentAirTime?.channelId;
                    if (channelId) {
                        // get channel image
                        item.subImage =
                            await this.domains.imagesRepository.getWhiteChannelImage(item.recentAirTime?.imagesChannel);
                    }
                }
            }
        }
        return guide;
    }
    async getGuide(pageSize, pageNumber, from, till, channels) {
        const guide = await this.domains.guidesRepository.getGuide(pageSize, pageNumber, from, till, channels);
        if (guide.items) {
            for (let item of guide.items) {
                if (item.images !== null) {
                    item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
                    const channelId = item.recentAirTime?.channelId;
                    if (channelId) {
                        // get channel image
                        item.subImage =
                            await this.domains.imagesRepository.getWhiteChannelImage(item.recentAirTime?.imagesChannel);
                    }
                }
            }
        }
        return guide;
    }
    async getSegment(channelIds, fromTime, tillTime) {
        const fromDate = new Date(fromTime);
        const tillDate = new Date(tillTime);
        const response = await this.getGuide(500, 1, fromDate, tillDate, channelIds);
        const result = {};
        const programs = response.items ?? [];
        programs.forEach(program => {
            const channelId = program.recentAirTime.channelId;
            const beginTime = program.recentAirTime.startTime;
            if (!result[`${channelId}`]) {
                result[`${channelId}`] = {};
            }
            result[`${channelId}`][`${beginTime}`] = program;
        });
        return result;
    }
    async getSegmentFromCache(channelIds, fromTime) {
        const timeSpanHs = GuideConstants.PROGRAMS_PAGE_SIZE;
        // extra protection from cache overflow
        const dateFrom = new Date(fromTime);
        dateFrom.setHours(Math.floor(dateFrom.getHours() / timeSpanHs) * timeSpanHs, 0, 0, 0);
        const cachedFromTime = dateFrom.getTime();
        const timeSpan = this.getSegmentDuration();
        const cachedTillTime = cachedFromTime + timeSpan;
        const result = {};
        const cacheMissIds = [];
        const keyFn = (fromTime, tillTime, channelId) => `GuideProgramsSegment:${fromTime}:${tillTime}:${channelId}`;
        for (let channelId of channelIds) {
            const key = keyFn(cachedFromTime, cachedTillTime, channelId);
            let cachedChannelResult = await this.domains.idbCacher.get(key).catch((e) => {
                console.error(e);
                return null;
            });
            if (cachedChannelResult === null) {
                cacheMissIds.push(channelId);
            }
            else {
                result[`${channelId}`] = cachedChannelResult;
            }
        }
        if (cacheMissIds.length) {
            let apiResult = await this.getSegment(cacheMissIds, cachedFromTime, cachedTillTime);
            const keys = Object.keys(apiResult);
            for (let channelId of keys) {
                const key = keyFn(cachedFromTime, cachedTillTime, parseInt(channelId));
                await this.domains.idbCacher.put(key, apiResult[channelId], { ttl: this.cacheTtl }).catch((e) => {
                    console.error(e);
                });
            }
            Object.assign(result, apiResult);
        }
        return result;
    }
    getSegmentBeginTime(time) {
        const date = new Date(time);
        const timeSpanHs = GuideConstants.PROGRAMS_PAGE_SIZE;
        date.setHours(Math.floor(date.getHours() / timeSpanHs) * timeSpanHs, 0, 0, 0);
        return date.getTime();
    }
    getSegmentDuration() {
        return GuideConstants.PROGRAMS_PAGE_SIZE * 60 * 60 * 1000;
    }
    async getChannelProgramByTime(channelId, time) {
        const segment = await this.getSegmentFromCache([channelId], time);
        const programsMap = segment[`${channelId}`] ?? {};
        const keys = Object.keys(programsMap)
            .map(k => parseInt(k))
            .sort();
        for (let key of keys) {
            const beginTime = key;
            const program = programsMap[`${key}`];
            if (program) {
                const endTime = beginTime + program.length * 60 * 1000;
                if (beginTime <= time && endTime > time) {
                    return program;
                }
            }
        }
        return null;
    }
    async searchPrograms(filter, pageSize, pageNumber) {
        const result = await this.domains.guidesRepository.searchPrograms(filter, pageSize, pageNumber);
        for (let item of result.items ?? []) {
            if (item.images) {
                item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
            }
        }
        return result;
    }
    /**
     * Get all live programs by searchText.
     *
     * @param {GuideSearchFilter} filter
     * @param {number} pageSize
     * @param {number} pageNumber
     * @return {Promise<ProgramGuide>}
     */
    async searchLivePrograms(filter, pageSize, pageNumber) {
        const result = await this.domains.guidesRepository.searchLivePrograms(filter, pageSize, pageNumber);
        for (let item of result.items ?? []) {
            if (item.images) {
                item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
            }
        }
        return result;
    }
}

class HomeService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    /**
     * Load Home content with the images
     * @returns the Home content data
     */
    async getHomeContent(contentType, itemsCount, pageNumber, channels) {
        let content = null;
        const channelIds = channels.map(channel => channel.id).filter(id => id !== null);
        switch (contentType) {
            case HomeContentType.Movies: {
                content = await this.domains.guidesRepository.getMoviesOnTV(itemsCount, pageNumber, channelIds);
                break;
            }
            case HomeContentType.Sports: {
                content = await this.domains.guidesRepository.getSportsOnTV(itemsCount, pageNumber, channelIds);
                break;
            }
            case HomeContentType.Kids: {
                content = await this.domains.guidesRepository.getTVForKids(itemsCount, pageNumber, channelIds);
                break;
            }
            case HomeContentType.News: {
                content = await this.domains.guidesRepository.getNewsOnTv(itemsCount, pageNumber, channelIds);
                break;
            }
            case HomeContentType.Trends: {
                content = await this.domains.mediaRepository.getTrends();
                break;
            }
            case HomeContentType.Olympics: {
                content = await this.domains.guidesRepository.getOlympicsOnTv(itemsCount, pageNumber, channelIds);
                break;
            }
            case HomeContentType.LiveSeries: {
                content = await this.domains.guidesRepository.getLiveSeriesOnTv(itemsCount, pageNumber, channelIds);
                break;
            }
        }
        const items = content.items;
        if (items === null) {
            return new ProgramGuide([], null, new ItemPaging(itemsCount, pageNumber, 0, 0));
        }
        const vCloudItems = [];
        for (let item of items) {
            if (item.images !== null) {
                // get program image
                item.image = await this.domains.imagesRepository.getProgramImage(Array.from(item.images));
            }
            const channelId = item.recentAirTime?.channelId;
            if (channelId) {
                // get channel image
                item.subImage =
                    await this.domains.imagesRepository.getWhiteChannelImage(item.recentAirTime?.imagesChannel);
            }
            const channel = channels.find(channel => channel.id === item?.recentAirTime?.channelId) ?? null;
            if (PlayItem.isVCloud(item, channel)) {
                vCloudItems.push(item);
            }
        }
        // vCloud programs progress. For the clients only. VCloud progress for the guests is always 0
        if (typeof this.domains.domainsSettings.sessionId === "string") { //TODO: Investigate. The request properties may be do in stores/HomePage. It should to improve perfomance home page. 
            const ids = vCloudItems
                .filter(({ id }) => id !== null)
                .map(({ id }) => id);
            const props = await this.domains.mediaRepository.getItemProperties(ids, ContentType.LiveTV, [ContentItemProps.WatchedPosition]);
            for (let prop of props) {
                const item = items.find((item) => item.id === prop.id);
                if (item) {
                    item.streamPosition = prop.streamPosition;
                }
            }
        }
        // sort by startTime
        content.items?.sort((item1, item2) => {
            const startTime1 = item1.recentAirTime?.startTime;
            const startTime2 = item2.recentAirTime?.startTime;
            if (startTime1 === startTime2) {
                return 0;
            }
            if (!startTime1) {
                return -1;
            }
            if (!startTime2) {
                return 1;
            }
            return startTime1 > startTime2 ? -1 : 1;
        });
        return content;
    }
}

class FavoritesService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    async getFavoritesOnDemand(pageNumber, itemsOnPage) {
        const response = await this.domains
            .favoritesRepository
            .getFavoritesOnDemand(pageNumber, itemsOnPage);
        const items = response.items ?? [];
        for (let item of items) {
            if (item.images !== null) {
                item.image = await this.domains
                    .imagesRepository
                    .getOnDemandImage(Array.from(item.images));
            }
        }
        response.items = items;
        return response;
    }
    async getFavoritesLiveTv(pageNumber, itemsOnPage) {
        const response = await this.domains
            .favoritesRepository
            .getFavoritesPrograms(pageNumber, itemsOnPage);
        const items = response.items ?? [];
        for (let item of items) {
            if (item.images !== null) {
                item.image = await this.domains
                    .imagesRepository
                    .getProgramImage(Array.from(item.images));
                const channelId = item.recentAirTime?.channelId;
                if (channelId) {
                    // get channel image
                    item.subImage =
                        await this.domains.imagesRepository.getWhiteChannelImage(item.recentAirTime?.imagesChannel);
                }
            }
        }
        response.items = items;
        return response;
    }
}

class ChannelsService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    async loadShowtimesChannels(id) {
        const channels = await this.domains.channelsRepository.getShowtimesChannels(id, true);
        if (channels && channels.items) {
            for (const channel of channels.items) {
                if (channel.id) {
                    channel.image = await this.domains.imagesRepository.getWhiteChannelImage(channel.images);
                }
            }
        }
        return channels.items ? [...channels.items] : [];
    }
    async loadChannels(pageNumber, itemsOnPage) {
        const availableChannels = await this
            .domains
            .channelsRepository
            .getChannels(true, itemsOnPage, pageNumber);
        const notAvailableChannels = await this
            .domains
            .channelsRepository
            .getChannels(false, itemsOnPage, pageNumber);
        const outOfHomeChannels = await this
            .domains
            .channelsRepository
            .getChannels(true, itemsOnPage, pageNumber, undefined, true);
        if (availableChannels.items) {
            for (const channel of availableChannels.items) {
                if (channel.id) {
                    channel.image = await this.domains.imagesRepository.getWhiteChannelImage(channel.images);
                }
            }
        }
        if (notAvailableChannels.items) {
            for (const channel of notAvailableChannels.items) {
                if (channel.id) {
                    channel.image = await this.domains.imagesRepository.getWhiteChannelImage(channel.images);
                }
            }
        }
        if (outOfHomeChannels.items) {
            for (const channel of outOfHomeChannels.items) {
                if (channel.id) {
                    channel.image = await this.domains.imagesRepository.getWhiteChannelImage(channel.images);
                }
            }
        }
        return new ChannelsData(availableChannels, notAvailableChannels, outOfHomeChannels);
    }
    async loadAvailableChannels(pageNumber, itemsOnPage) {
        const availableChannels = await this
            .domains
            .channelsRepository
            .getChannels(true, itemsOnPage, pageNumber);
        if (availableChannels.items) {
            for (const channel of availableChannels.items) {
                if (channel.id) {
                    channel.image = await this.domains.imagesRepository.getWhiteChannelImage(channel.images);
                }
            }
        }
        return availableChannels.items ? [...availableChannels.items] : null;
    }
}

class ClientMessagesService {
    domains;
    timerId = null;
    isActive = false;
    interval = null;
    constructor(domains) {
        this.domains = domains;
    }
    wait() {
        return new Promise((resolve, _) => {
            if (!this.interval) {
                return;
            }
            this.timerId = setTimeout(resolve, this.interval);
        });
    }
    async *startReceiving(interval) {
        if (this.isActive) {
            return;
        }
        this.isActive = true;
        if (interval) {
            this.interval = interval;
        }
        while (this.isActive) {
            try {
                const messages = await this.domains.clientRepository.getMessages();
                yield messages.map((m) => m);
                await this.wait();
            }
            catch (_) {
                this.stopReceiving();
            }
        }
    }
    stopReceiving() {
        if (!this.isActive) {
            return;
        }
        this.isActive = false;
        clearTimeout(this.timerId);
        this.timerId = null;
    }
}

class CreditsService {
    domains;
    constructor(domains) {
        this.domains = domains;
    }
    async getCredits(id, contentType) {
        const items = await this.domains
            .creditsRepository
            .getCredits(id, contentType);
        for (let item of items) {
            if (item.images === null) {
                continue;
            }
            item.image = await this.domains
                .imagesRepository
                .getActorImage(Array.from(item.images));
        }
        return [...items];
    }
    async searchCredits(keyword, pageNumber, itemsOnPage) {
        const creditsPage = await this.domains
            .creditsRepository
            .searchCredits(keyword, itemsOnPage, pageNumber);
        for (let item of creditsPage.items) {
            if (item.images === null) {
                continue;
            }
            item.image = await this.domains
                .imagesRepository
                .getActorImage(Array.from(item.images));
        }
        return creditsPage;
    }
    async getMedioGraphyVod(id) {
        const medioGraphy = await this.domains
            .creditsRepository
            .getMedioGraphy(Number(id), ContentType.SVOD);
        if (medioGraphy === null) {
            return null;
        }
        if (medioGraphy.person) {
            medioGraphy.person.image = await this.domains.imagesRepository.getActorImage(Array.from(medioGraphy.personImage ? [medioGraphy.personImage] : []));
        }
        const imagePromises = [];
        medioGraphy.mediographySections?.forEach((section) => {
            if (section.items === null || section.items.length === 0) {
                return;
            }
            section.items.forEach((item) => {
                if (item.images === null) {
                    return;
                }
                imagePromises.push((async () => {
                    item.image = await this.domains.imagesRepository.getOnDemandImage(Array.from(item.images ?? []));
                })());
            });
        });
        await Promise.all(imagePromises);
        return medioGraphy;
    }
    async searchRelatedCredits(id) {
        const items = await this.domains
            .creditsRepository
            .searchRelatedCredits(Number(id), ContentType.SVOD);
        for (let item of items) {
            if (item.images === null) {
                continue;
            }
            item.image = await this.domains
                .imagesRepository
                .getActorImage(Array.from(item.images));
        }
        return [...items];
    }
}

class ClientService {
    constructor() { }
    /**
     * Parse client app settings
     * @returns {errorCode, errorMessage, adultPin, appVersion, loginId, vcloudDelay}
     */
    async parseSettings(user) {
        const errorCode = user?.appSettings?.settings?.find((item) => item.key === "errorCode")?.value ?? null;
        const errorMessage = user?.appSettings?.settings?.find((item) => item.key === "errorMessage")?.value ?? null;
        const adultPin = user?.appSettings?.settings?.find((item) => item.key === "adult_pin")?.value ?? null;
        const appVersion = user?.appSettings?.settings?.find((item) => item.key === "box.app_version")?.value ?? null;
        const loginId = user?.appSettings?.settings?.find((item) => item.key === "login.id")?.value ?? null;
        const vcloudDelay = user?.appSettings?.settings?.find((item) => item.key === "vcloud.request.delay")?.value ?? null;
        return { errorCode, errorMessage, adultPin, appVersion, loginId, vcloudDelay };
    }
}

class PlayerService {
    constructor() { }
}

class Services {
    /**
     * ServiceLocator approach to access the global DI container that is needed inside stores' actions
     */
    static Instance;
    domains;
    vod;
    search;
    guide;
    home;
    channels;
    favorites;
    clientMessages;
    credits;
    client;
    player;
    constructor(domains) {
        this.domains = domains;
        this.vod = new VodService(domains);
        this.search = new SearchService(domains);
        this.guide = new GuideService(domains);
        this.home = new HomeService(domains);
        this.favorites = new FavoritesService(domains);
        this.channels = new ChannelsService(domains);
        this.clientMessages = new ClientMessagesService(domains);
        this.credits = new CreditsService(domains);
        this.client = new ClientService();
        this.player = new PlayerService();
        if (Services.Instance) {
            console.warn("Glocal service container was already initialized!");
        }
        Services.Instance = this;
    }
}

export { Services };
//# sourceMappingURL=index.esm.min.js.map
